<template>
    <ul class="nested-list menu-list">
        <li
            v-for="(item, index) in flatten(items)"
            :key="index"
            :class="{ hidden: !(hasPermission(item) && component(item)) }"
        >
            <component
                :is="component(item)"
                v-if="hasPermission(item) && component(item)"
                :item="item"
                :auto-expand="expandUuid"
                @toggling-menu="toggleMenu"
                @expand="expand"
            />
            <nested-list
                v-if="item.items"
                v-show="showingMenu"
                :id="`${item.type}-${item.id}`"
                :items="item.items"
                @expand="expand"
            />
        </li>
    </ul>
</template>

<script>
import { pascalCase } from 'change-case';
import flatten from 'lodash/flatten.js';
import { mapState } from 'vuex';

import * as NestedListItems from '@/components/nested-list/nested-list-item/Index.js';
import Course from '@/models/Course.js';
import CourseTemplate from '@/models/CourseTemplate.js';

export default {
    name: 'NestedList',

    components: NestedListItems.default,

    props: {
        items: {
            default: null,
            type: Array,
        },
    },

    emits: ['expand'],

    data: () => ({
        showingMenu: false,
        expandUuid: null,
        isDisabled: false,
    }),

    computed: {
        ...mapState('Auth', { user: state => state.user }),

        isCourse() {
            return !this.$route.name?.includes('template');
        },

        courseId() {
            return this.isCourse ? this.$route.params.courseId : this.$route.params.id;
        },
    },

    async created() {
        this.updateObjectiveTitles();
    },

    methods: {
        flatten,

        component(item) {
            if (!item.type) return null;

            return pascalCase(item.type);
        },

        hasPermission(item) {
            // Old system
            let course = this.isCourse
                ? this.$store.getters['Courses/get'](this.courseId)
                : this.$store.getters['CourseTemplates/get'](this.courseId);

            // Vuex orm system
            if (!course) {
                course = this.isCourse
                    ? Course.query().with('groups').find(this.courseId)
                    : CourseTemplate.query().with('groups').find(this.courseId);
            }

            return (
                !item.permission ||
                this.$can(item.permission.action, item.permission.subject) ||
                (this.isCourse
                    ? this.user.hasGroupPermissionWithinCourse(course, item.permission.name)
                    : this.user.hasGroupPermissionWithinCourseTemplate(course, item.permission.name))
            );
        },

        toggleMenu(toggle) {
            const el = document.getElementById(`${toggle.item.type}-${toggle.item.id}`);

            if (el) el.style.display = toggle.display ? 'block' : 'none';
        },

        expand(uuid) {
            this.expandUuid = uuid;

            this.$emit('expand', uuid);
        },

        updateObjectiveTitles() {
            if (!this.isCourse) return;

            if (this.items[0]?.type === 'section') {
                this.items.forEach(item => {
                    if (item.section_id && item.items) {
                        if (item.items[0].has_fallback_text) {
                            item.items[0].text = `Week ${item.week_number} Objectives`;
                        }

                        return item.items[0].text;
                    }

                    return item;
                });
            }
        },
    },
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';
.nested-list.menu-list {
    li.hidden {
        border-top: none;
    }
}
.section-item__text {
    align-items: center;
}
</style>
